// src/custom-data/components/CreateFieldMappingFieldForm.tsx
import { useCallback as useCallback4, useState as useState4 } from "react";
import { createUUID } from "shared-lib";
import { Button, ButtonList, FieldLabel as FieldLabel2 } from "shared-ui";

// src/custom-data/components/MappableForm.tsx
import { useCallback as useCallback3, useEffect as useEffect3, useState as useState3 } from "react";
import { isNullOrWhiteSpace } from "shared-lib";
import { FieldLabel, Input, SelectMenu as SelectMenu3 } from "shared-ui";

// src/custom-data/models/FieldMappings.ts
var MappableProcessorType = /* @__PURE__ */ ((MappableProcessorType3) => {
  MappableProcessorType3["Field"] = "Field";
  MappableProcessorType3["Literal"] = "Literal";
  MappableProcessorType3["FieldFormat"] = "FieldFormat";
  MappableProcessorType3["Expression"] = "Expression";
  return MappableProcessorType3;
})(MappableProcessorType || {});
var processTypes = [
  {
    id: "Field" /* Field */,
    name: "Field" /* Field */
  },
  {
    id: "FieldFormat" /* FieldFormat */,
    name: "FieldFormat" /* FieldFormat */
  },
  {
    id: "Literal" /* Literal */,
    name: "Literal" /* Literal */
  },
  {
    id: "Expression" /* Expression */,
    name: "Expression" /* Expression */
  }
];
var MappableDataType = /* @__PURE__ */ ((MappableDataType3) => {
  MappableDataType3["String"] = "String";
  MappableDataType3["Integer"] = "Integer";
  MappableDataType3["Float"] = "Float";
  MappableDataType3["DateTime"] = "DateTime";
  return MappableDataType3;
})(MappableDataType || {});
var dataTypes = [
  {
    id: "String" /* String */,
    name: "String" /* String */
  },
  {
    id: "Integer" /* Integer */,
    name: "Integer" /* Integer */
  },
  {
    id: "Float" /* Float */,
    name: "Float" /* Float */
  },
  {
    id: "DateTime" /* DateTime */,
    name: "DateTime" /* DateTime */
  }
];
function hasFieldDefinition(processType) {
  if (processType === null) {
    return false;
  }
  return processType === "Field" /* Field */ || processType === "FieldFormat" /* FieldFormat */;
}
function hasValueField(processType) {
  if (processType === null) {
    return false;
  }
  return processType === "Literal" /* Literal */ || processType === "FieldFormat" /* FieldFormat */ || processType === "Expression" /* Expression */;
}
function getDataType(dataType) {
  return dataType.key;
}
function fieldDefinitionToListItem(definition) {
  return {
    id: definition.key,
    name: definition.label
  };
}
function fieldDefinitionsToListItems(fields) {
  return fields.map(fieldDefinitionToListItem);
}
function integrationFieldMappingToListItem(mapping) {
  return {
    id: mapping.fieldId,
    name: mapping.fieldLabel
  };
}
function integrationFieldMappingsToListItems(fields) {
  return fields.map(integrationFieldMappingToListItem);
}

// src/custom-data/components/ProcessorTypeList.tsx
import { useCallback, useEffect, useState } from "react";
import { SelectMenu } from "shared-ui";
import { jsx } from "react/jsx-runtime";
var ProcessorTypeList = ({
  type,
  onSelect
}) => {
  const [item, setTtem] = useState(null);
  const onItemChange = useCallback(
    (item2) => {
      const processorType = item2.id;
      onSelect(processorType);
    },
    [item]
  );
  useEffect(() => {
    if (type) {
      const item2 = processTypes.find((i) => i.id == type);
      if (item2) {
        setTtem(item2);
      }
    }
  }, []);
  return /* @__PURE__ */ jsx(
    SelectMenu,
    {
      title: "Processor",
      items: processTypes,
      onChange: onItemChange,
      value: item
    }
  );
};

// src/custom-data/components/DataTypeList.tsx
import { useCallback as useCallback2, useEffect as useEffect2, useState as useState2 } from "react";
import { SelectMenu as SelectMenu2 } from "shared-ui";
import { jsx as jsx2 } from "react/jsx-runtime";
var DataTypeList = ({ type, onSelect }) => {
  const [item, setItem] = useState2(null);
  const onItemChange = useCallback2(
    (item2) => {
      setItem(item2);
    },
    [item]
  );
  useEffect2(() => {
    if (type) {
      const item2 = dataTypes.find((i) => i.id == type);
      if (item2) {
        setItem(item2);
      }
    }
  }, []);
  useEffect2(() => {
    if (type && item) {
      const dataType = item.id;
      onSelect(dataType);
    }
  }, [item]);
  return /* @__PURE__ */ jsx2(
    SelectMenu2,
    {
      title: "Data Type",
      items: dataTypes,
      onChange: onItemChange,
      value: item
    }
  );
};

// src/custom-data/components/MappableForm.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var MappableForm = ({
  fieldDefinitions,
  fields,
  onChange
}) => {
  const [field, setField] = useState3(null);
  const [name, setName] = useState3(null);
  const [value, setValue] = useState3(null);
  const [dataType, setDataType] = useState3(
    "String" /* String */
  );
  const [processorType, setProcessorType] = useState3("Field" /* Field */);
  const onSetField = useCallback3(
    (item) => {
      setField(item);
      const field2 = fieldDefinitions.find((d) => d.key === item.id);
      if (!field2) {
        throw "Invalid Source Definitions List";
      }
      if (isNullOrWhiteSpace(name)) {
        setName(field2.label);
        setDataType(getDataType(field2.dataType));
      }
    },
    [field, name, dataType]
  );
  const onSetName = useCallback3(
    (value2) => {
      setName(value2);
    },
    [name]
  );
  const onSetValue = useCallback3(
    (value2) => {
      setValue(value2);
    },
    [value]
  );
  const onSetDataType = useCallback3(
    (value2) => {
      setDataType(value2);
    },
    [dataType]
  );
  useEffect3(() => {
    if (!processorType || !dataType || !name) {
      return;
    }
    let key, label, dataTypeKey;
    if (hasFieldDefinition(processorType) && field) {
      const fieldDefinition = fieldDefinitions.find((d) => d.key === field.id);
      if (!fieldDefinition) {
        throw "Invalid Source Definitions List";
      }
      key = fieldDefinition.key;
      label = fieldDefinition.label;
      dataTypeKey = fieldDefinition.dataType.key;
    } else {
      key = name;
      label = name;
      dataTypeKey = dataType;
    }
    onChange({
      key,
      label,
      dataTypeKey,
      processorTypeKey: processorType,
      value
    });
  }, [field, name, dataType, value]);
  return /* @__PURE__ */ jsx3("div", { children: /* @__PURE__ */ jsxs("div", { className: "p-2", children: [
    /* @__PURE__ */ jsx3("div", { className: "p-2", children: /* @__PURE__ */ jsx3(
      ProcessorTypeList,
      {
        type: processorType ?? "Field" /* Field */,
        onSelect: setProcessorType
      }
    ) }),
    hasFieldDefinition(processorType) ? /* @__PURE__ */ jsx3("div", { className: "p-2", children: /* @__PURE__ */ jsx3(
      SelectMenu3,
      {
        title: "Field",
        items: fields,
        onChange: onSetField,
        value: field
      }
    ) }) : /* @__PURE__ */ jsx3("div", { className: "p-2", children: /* @__PURE__ */ jsx3(DataTypeList, { onSelect: onSetDataType, type: dataType }) }),
    /* @__PURE__ */ jsxs("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx3("div", { className: "m-1", children: /* @__PURE__ */ jsx3(FieldLabel, { htmlFor: "sourceName", label: "Name" }) }),
      /* @__PURE__ */ jsx3(
        Input,
        {
          name: "sourceName",
          value: name || "",
          onValueChange: onSetName
        },
        "sourceName"
      )
    ] }),
    hasValueField(processorType) ? /* @__PURE__ */ jsxs("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx3("div", { className: "m-1", children: /* @__PURE__ */ jsx3(FieldLabel, { htmlFor: "sourceValue", label: "Value" }) }),
      /* @__PURE__ */ jsx3(
        Input,
        {
          name: "sourceValue",
          value: value || "",
          onValueChange: onSetValue
        },
        "sourceValue"
      )
    ] }) : /* @__PURE__ */ jsx3("div", {})
  ] }) });
};

// src/custom-data/components/CreateFieldMappingFieldForm.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var CreateFieldMappingFieldForm = ({
  sourceFieldDefinitions,
  targetFieldDefinitions,
  sourceFields,
  targetFields,
  onCreated,
  onCancel
}) => {
  const [source, setSource] = useState4(null);
  const onSetSource = useCallback4(
    (value) => {
      setSource(value);
    },
    [source]
  );
  const [target, setTarget] = useState4(null);
  const onSetTarget = useCallback4(
    (value) => {
      setTarget(value);
    },
    [target]
  );
  const onAdd = useCallback4(() => {
    if (!source || !target) {
      return;
    }
    const id = createUUID();
    const field = {
      id,
      source,
      target
    };
    onCreated(field);
  }, [source, target]);
  return /* @__PURE__ */ jsxs2("div", { children: [
    /* @__PURE__ */ jsxs2("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx4("div", { className: "border-b px-2  py-3", children: /* @__PURE__ */ jsx4(FieldLabel2, { color: "primary", label: "Source" }) }),
      /* @__PURE__ */ jsx4(
        MappableForm,
        {
          fieldDefinitions: sourceFieldDefinitions,
          fields: sourceFields,
          onChange: onSetSource
        }
      )
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx4("div", { className: "border-b px-2  py-3", children: /* @__PURE__ */ jsx4(FieldLabel2, { color: "primary", label: "Target" }) }),
      /* @__PURE__ */ jsx4(
        MappableForm,
        {
          fieldDefinitions: targetFieldDefinitions,
          fields: targetFields,
          onChange: onSetTarget
        }
      )
    ] }),
    /* @__PURE__ */ jsxs2(ButtonList, { children: [
      /* @__PURE__ */ jsx4(Button, { color: "primary", disabled: !source || !target, clicked: onAdd, children: "Add" }),
      /* @__PURE__ */ jsx4(Button, { clicked: onCancel, children: "Cancel" })
    ] })
  ] });
};

// src/custom-data/components/FieldMappingConfigurationCreateForm.tsx
import { useCallback as useCallback5 } from "react";
import { useForm } from "react-hook-form";
import {
  Button as Button2,
  ButtonList as ButtonList2,
  DependentSelectField,
  FormInput,
  FormRow
} from "shared-ui";

// src/lib/Events.ts
var AllEntityEventTypes = "ALL";
var EntityEventTypes = [
  {
    id: AllEntityEventTypes,
    label: "All"
  },
  {
    id: "INSERTED",
    label: "Inserted"
  },
  {
    id: "UPDATED",
    label: "Updated"
  },
  {
    id: "DELETED",
    label: "Deleted"
  }
];

// src/lib/Systems.ts
var ElevateVacancyEntity = "Vacancy";
var ElevateProfileEntity = "Profile";
var ElevateApplicationEntity = "Application";
var ElevateEntities = [
  { id: ElevateVacancyEntity, name: ElevateVacancyEntity },
  { id: ElevateProfileEntity, name: ElevateProfileEntity },
  { id: ElevateApplicationEntity, name: ElevateApplicationEntity }
];
var BullhornJobOrderEntity = "JobOrder";
var BullhornCandidateEntity = "Candidate";
var BullhornJobSubmissionEntity = "JobSubmission";
var BullhornEntities = [
  { id: BullhornJobOrderEntity, name: BullhornJobOrderEntity },
  { id: BullhornCandidateEntity, name: BullhornCandidateEntity },
  { id: BullhornJobSubmissionEntity, name: BullhornJobSubmissionEntity }
];
var ElevateSystem = "Elevate";
var BullhornSystem = "Bullhorn";
var IntegrationSystems = [
  { id: ElevateSystem, name: ElevateSystem },
  { id: BullhornSystem, name: BullhornSystem }
];
var IntegrationEntityMap = /* @__PURE__ */ new Map();
IntegrationEntityMap.set(ElevateSystem, ElevateEntities);
IntegrationEntityMap.set(BullhornSystem, BullhornEntities);

// src/lib/EventLogs.ts
var EventLogItemTypesList = [
  {
    id: "All",
    name: "All"
  },
  {
    id: "BullhornTenant",
    name: "Tenant"
  },
  {
    id: "BullhornCandidate",
    name: "Candidate"
  },
  {
    id: "BullhornJobOrder",
    name: "Job Order"
  },
  {
    id: "BullhornJobSubmission",
    name: "Job Submission"
  }
];
var EventLogItemLevelList = [
  {
    id: "All",
    label: "All"
  },
  {
    id: "Info",
    label: "Info"
  },
  {
    id: "Warning",
    label: "Warning"
  },
  {
    id: "Error",
    label: "Error"
  }
];

// src/custom-data/components/FieldMappingConfigurationCreateForm.tsx
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var FieldMappingConfigurationCreateForm = ({
  onSubmit
}) => {
  const submit = useCallback5((form) => {
    if (!form.name || !form.sourceField || !form.sourceField.parentId || !form.sourceField.childId || !form.targetField || !form.targetField.parentId || !form.targetField.childId) {
      return;
    }
    onSubmit({
      name: form.name,
      sourceType: form.sourceField.childId,
      sourceSystem: form.sourceField.parentId,
      targetType: form.targetField.childId,
      targetSystem: form.targetField.parentId
    });
  }, []);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm();
  return /* @__PURE__ */ jsx5("form", { onSubmit: handleSubmit(submit), children: /* @__PURE__ */ jsx5("div", { className: "shadow sm:rounded-md", children: /* @__PURE__ */ jsxs3("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    /* @__PURE__ */ jsxs3(
      FormRow,
      {
        label: /* @__PURE__ */ jsx5(
          "label",
          {
            htmlFor: "name",
            className: "block text-sm font-medium text-gray-700",
            children: "Name"
          }
        ),
        children: [
          /* @__PURE__ */ jsx5(
            FormInput,
            {
              type: "text",
              placeholder: " Name ",
              defaultValue: "",
              name: "name",
              required: true,
              register
            }
          ),
          errors.nameRequired && /* @__PURE__ */ jsx5("span", { children: "A name is required" })
        ]
      }
    ),
    /* @__PURE__ */ jsx5(
      FormRow,
      {
        label: /* @__PURE__ */ jsx5(
          "label",
          {
            htmlFor: "name",
            className: "block text-sm font-medium text-gray-700",
            children: "Source"
          }
        ),
        children: /* @__PURE__ */ jsx5(
          DependentSelectField,
          {
            className: "w-full",
            name: "sourceField",
            control,
            parentTitle: "System",
            childTitle: "Type",
            parentItems: IntegrationSystems,
            childItems: IntegrationEntityMap
          }
        )
      }
    ),
    /* @__PURE__ */ jsx5(
      FormRow,
      {
        label: /* @__PURE__ */ jsx5(
          "label",
          {
            htmlFor: "name",
            className: "block text-sm font-medium text-gray-700",
            children: "Target"
          }
        ),
        children: /* @__PURE__ */ jsx5(
          DependentSelectField,
          {
            className: "w-full",
            name: "targetField",
            control,
            parentTitle: "System",
            childTitle: "Type",
            parentItems: IntegrationSystems,
            childItems: IntegrationEntityMap
          }
        )
      }
    ),
    /* @__PURE__ */ jsx5(ButtonList2, { children: /* @__PURE__ */ jsx5(Button2, { type: "submit", children: "Create" }) })
  ] }) }) });
};

// src/custom-data/components/__generated__/FieldMappingConfigurationDetail_fieldMappingConfiguration.graphql.ts
var node = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v2 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    v1
  ], v3 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FieldMappingConfigurationDetail_fieldMappingConfiguration",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationSystemsType",
        "kind": "LinkedField",
        "name": "sourceSystem",
        "plural": false,
        "selections": v2,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationSystemsType",
        "kind": "LinkedField",
        "name": "targetSystem",
        "plural": false,
        "selections": v2,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationMappableAction",
        "kind": "LinkedField",
        "name": "mappings",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappable",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappable",
            "kind": "LinkedField",
            "name": "target",
            "plural": false,
            "selections": v3,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "IntegrationFieldMappingConfiguration",
    "abstractKey": null
  };
}();
node.hash = "062a17927b112be4f5f23f9d09d29b32";
var FieldMappingConfigurationDetail_fieldMappingConfiguration_graphql_default = node;

// src/custom-data/components/FieldMappingConfigurationDetail.tsx
import { Fragment } from "react";
import { useFragment } from "react-relay";
import {
  AuditFields,
  DescriptionItem,
  DescriptionList,
  EdColumnCell,
  EdRow,
  EdTable
} from "shared-ui";
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var fragment = FieldMappingConfigurationDetail_fieldMappingConfiguration_graphql_default;
var columns = [
  { id: "label", name: "Label" },
  { id: "processorType", name: "Processor Type" },
  { id: "dataType", name: "Data Type" },
  { id: "dataValue", name: "Data Value" },
  { id: "transform", name: "Transform" },
  { id: "target", name: "Target" },
  { id: "type", name: "Type" },
  { id: "value", name: "Value" }
];
var FieldMappingConfigurationDetail = ({
  fieldMappingConfiguration: fieldMappingConfiguration2,
  actions,
  className
}) => {
  const data = useFragment(
    fragment,
    fieldMappingConfiguration2
  );
  const rows = data.mappings.map((action) => {
    return /* @__PURE__ */ jsxs4(EdRow, { clicked: () => {
    }, rowKey: action.id, children: [
      /* @__PURE__ */ jsx6(EdColumnCell, { children: action.source.label }),
      /* @__PURE__ */ jsx6(EdColumnCell, { children: action.source.processorTypeKey }),
      /* @__PURE__ */ jsx6(EdColumnCell, { children: action.source.dataTypeKey }),
      /* @__PURE__ */ jsx6(EdColumnCell, { children: action.source.value ?? "" }),
      /* @__PURE__ */ jsx6(EdColumnCell, { children: /* @__PURE__ */ jsx6("div", { className: "font-medium text-gray-800", children: "Set" }) }),
      /* @__PURE__ */ jsx6(EdColumnCell, { children: action.target.label }),
      /* @__PURE__ */ jsx6(EdColumnCell, { children: action.target.processorTypeKey }),
      /* @__PURE__ */ jsx6(EdColumnCell, { children: action.target.dataTypeKey }),
      /* @__PURE__ */ jsx6(EdColumnCell, { children: action.target.value ?? "" })
    ] }, action.id);
  });
  return /* @__PURE__ */ jsx6("div", { className, children: /* @__PURE__ */ jsx6(
    DescriptionList,
    {
      heading: /* @__PURE__ */ jsx6("span", { className: "text-info-600", children: data.name }),
      description: /* @__PURE__ */ jsx6("div", { className: "mt-4", children: /* @__PURE__ */ jsx6(
        AuditFields,
        {
          createdOn: data.createdAt,
          updatedOn: data.updatedAt
        }
      ) }),
      items: /* @__PURE__ */ jsxs4(Fragment, { children: [
        actions,
        /* @__PURE__ */ jsx6(DescriptionItem, { label: "Source", children: /* @__PURE__ */ jsxs4("p", { className: "text-md pt-1 text-gray-500", children: [
          data.sourceSystem.displayName,
          " ",
          data.sourceType
        ] }) }),
        /* @__PURE__ */ jsx6(DescriptionItem, { label: "Target", children: /* @__PURE__ */ jsxs4("p", { className: "text-md pt-1 text-gray-500", children: [
          data.targetSystem.displayName,
          " ",
          data.targetType
        ] }) }),
        /* @__PURE__ */ jsx6("div", { className: "my-4 p-4", children: /* @__PURE__ */ jsx6(
          EdTable,
          {
            fixedHeight: false,
            defaultColumns: columns,
            rows
          }
        ) })
      ] })
    }
  ) });
};
var FieldMappingConfigurationDetail_default = FieldMappingConfigurationDetail;

// src/custom-data/components/FieldMappingConfigurationEditForm.tsx
import { useCallback as useCallback6 } from "react";
import { useForm as useForm2 } from "react-hook-form";
import { Button as Button3, ButtonList as ButtonList3, DependentSelectField as DependentSelectField2, FormRow as FormRow2 } from "shared-ui";
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var FieldMappingConfigurationEditForm = ({
  sourceSystem,
  sourceType,
  targetSystem,
  targetType,
  name,
  onSave,
  onCancel
}) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm2();
  const onSubmit = useCallback6((data) => {
    onSave(data);
  }, []);
  return /* @__PURE__ */ jsxs5("form", { onSubmit: handleSubmit(onSubmit), children: [
    /* @__PURE__ */ jsx7("div", { className: "px-2 py-4 font-medium", children: /* @__PURE__ */ jsxs5("p", { children: [
      "Mapping fields from",
      " ",
      /* @__PURE__ */ jsx7("span", { className: "text-info-500", children: sourceType }),
      " to",
      " ",
      /* @__PURE__ */ jsx7("span", { className: "text-info-500", children: targetType })
    ] }) }),
    /* @__PURE__ */ jsx7("div", { className: "shadow sm:rounded-md", children: /* @__PURE__ */ jsxs5("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
      /* @__PURE__ */ jsxs5(
        FormRow2,
        {
          label: /* @__PURE__ */ jsx7(
            "label",
            {
              htmlFor: "name",
              className: "block text-sm font-medium text-gray-700",
              children: "Name"
            }
          ),
          children: [
            /* @__PURE__ */ jsx7(
              "input",
              {
                type: "text",
                className: "focus:ring-info-500 focus:border-info-500 sm:text-md block w-full flex-1 rounded-none rounded-r-md border-gray-300",
                defaultValue: name,
                ...register("name", { required: true })
              }
            ),
            errors.nameRequired && /* @__PURE__ */ jsx7("span", { children: "A name is required" })
          ]
        }
      ),
      /* @__PURE__ */ jsx7(
        FormRow2,
        {
          label: /* @__PURE__ */ jsx7(
            "label",
            {
              htmlFor: "name",
              className: "block text-sm font-medium text-gray-700",
              children: "Source"
            }
          ),
          children: /* @__PURE__ */ jsx7(
            DependentSelectField2,
            {
              name: "sourceField",
              control,
              parentTitle: "System",
              childTitle: "Type",
              parentItems: IntegrationSystems,
              childItems: IntegrationEntityMap,
              initialParentId: sourceSystem,
              initialChildId: sourceType
            }
          )
        }
      ),
      /* @__PURE__ */ jsx7(
        FormRow2,
        {
          label: /* @__PURE__ */ jsx7(
            "label",
            {
              htmlFor: "name",
              className: "block text-sm font-medium text-gray-700",
              children: "Target"
            }
          ),
          children: /* @__PURE__ */ jsx7(
            DependentSelectField2,
            {
              name: "targetField",
              control,
              parentTitle: "System",
              childTitle: "Type",
              parentItems: IntegrationSystems,
              childItems: IntegrationEntityMap,
              initialParentId: targetSystem,
              initialChildId: targetType
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs5(ButtonList3, { children: [
        /* @__PURE__ */ jsx7(Button3, { type: "submit", children: "Save" }),
        /* @__PURE__ */ jsx7(Button3, { clicked: onCancel, children: "Cancel" })
      ] })
    ] }) })
  ] });
};

// src/custom-data/components/FieldMappingConfigurationFieldsForm.tsx
import { useCallback as useCallback8, useState as useState5 } from "react";
import { Button as Button5, ButtonList as ButtonList4, FormRow as FormRow3, FieldLabel as FieldLabel3, InlineEdit } from "shared-ui";

// src/custom-data/components/FieldMappingFieldsList.tsx
import { Fragment as Fragment2, useCallback as useCallback7 } from "react";
import {
  Button as Button4,
  EdActionCell,
  EdColumnCell as EdColumnCell2,
  EdRow as EdRow2,
  EdTable as EdTable2
} from "shared-ui";
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var columns2 = [
  { id: "source", name: "Source" },
  { id: "target", name: "Target" }
];
var FieldMappingFieldsList = ({
  fields,
  onRemove
}) => {
  const onRemoveField = useCallback7(
    (field) => {
      onRemove(field);
    },
    [fields]
  );
  const rows = fields.map((field) => {
    return /* @__PURE__ */ jsxs6(EdRow2, { clicked: () => {
    }, rowKey: field.id, children: [
      /* @__PURE__ */ jsx8(EdColumnCell2, { children: field.source.label }),
      /* @__PURE__ */ jsx8(EdColumnCell2, { children: field.target.label }),
      /* @__PURE__ */ jsx8(EdActionCell, { children: /* @__PURE__ */ jsx8(Button4, { clicked: () => onRemoveField(field), children: "Remove" }) })
    ] }, field.id);
  });
  return /* @__PURE__ */ jsx8(Fragment2, { children: /* @__PURE__ */ jsx8(
    EdTable2,
    {
      fixedHeight: false,
      defaultColumns: columns2,
      rows
    }
  ) });
};

// src/custom-data/components/FieldMappingConfigurationFieldsForm.tsx
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var FieldMappingConfigurationFieldsForm = ({
  sourceFieldDefinitions,
  targetFieldDefinitions,
  name,
  isBusy,
  actions,
  onSave,
  onCancel
}) => {
  const sourceFieldList = fieldDefinitionsToListItems(sourceFieldDefinitions);
  const targetFieldList = fieldDefinitionsToListItems(targetFieldDefinitions);
  const [currentName, setCurrentName] = useState5(name);
  const [currentActions, setCurrentActions] = useState5(actions);
  const [editState, setEditState] = useState5("Editing" /* Editing */);
  const onSetAdding = useCallback8(() => {
    setEditState("Adding" /* Adding */);
  }, [editState]);
  const onSetEditing = useCallback8(() => {
    setEditState("Editing" /* Editing */);
  }, [editState]);
  const onRemoveAction = useCallback8(
    (action) => {
      const actions2 = currentActions.filter((f) => f.id !== action.id);
      setCurrentActions(actions2);
    },
    [currentActions]
  );
  const onSubmit = useCallback8(() => {
    onSave({
      name: currentName,
      actions: currentActions
    });
  }, [currentName, currentActions]);
  const onAddAction = useCallback8(
    (action) => {
      const updatedActions = [...currentActions, action];
      setCurrentActions(updatedActions);
      onSetEditing();
    },
    [editState, currentActions]
  );
  let currentTab;
  switch (editState) {
    case "Editing" /* Editing */: {
      currentTab = /* @__PURE__ */ jsxs7("div", { className: "border border-gray-100 bg-white p-4 shadow", children: [
        /* @__PURE__ */ jsx9(
          FormRow3,
          {
            label: /* @__PURE__ */ jsx9("div", { className: "flex justify-between", children: /* @__PURE__ */ jsx9(FieldLabel3, { htmlFor: "Name", label: "Name" }) }),
            children: /* @__PURE__ */ jsx9(
              InlineEdit,
              {
                classes: "w-full",
                label: "Name",
                value: currentName,
                setValue: setCurrentName
              }
            )
          }
        ),
        /* @__PURE__ */ jsx9(
          FormRow3,
          {
            label: /* @__PURE__ */ jsxs7("div", { className: "flex items-center justify-between border-b py-2", children: [
              /* @__PURE__ */ jsx9(FieldLabel3, { htmlFor: "Fields", label: "Fields" }),
              /* @__PURE__ */ jsx9(Button5, { clicked: onSetAdding, children: "New" })
            ] }),
            children: /* @__PURE__ */ jsx9("div", { className: "py-4", children: /* @__PURE__ */ jsx9(
              FieldMappingFieldsList,
              {
                fields: currentActions,
                onRemove: onRemoveAction
              }
            ) })
          }
        ),
        /* @__PURE__ */ jsxs7(ButtonList4, { children: [
          /* @__PURE__ */ jsx9(Button5, { color: "gray", clicked: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsx9(Button5, { disabled: isBusy, clicked: onSubmit, children: "Save" })
        ] })
      ] });
      break;
    }
    case "Adding" /* Adding */: {
      currentTab = /* @__PURE__ */ jsxs7("div", { className: "mb-12 border border-gray-100 bg-white px-4 pt-2 shadow", children: [
        /* @__PURE__ */ jsx9("div", { className: "p-2", children: /* @__PURE__ */ jsx9(FieldLabel3, { size: "lg", label: "Add Field" }) }),
        /* @__PURE__ */ jsx9(
          CreateFieldMappingFieldForm,
          {
            sourceFieldDefinitions,
            targetFieldDefinitions,
            targetFields: targetFieldList,
            sourceFields: sourceFieldList,
            onCreated: onAddAction,
            onCancel: onSetEditing
          }
        )
      ] });
      break;
    }
  }
  return /* @__PURE__ */ jsx9("div", { className: "w-full px-2 py-4", children: currentTab });
};

// src/custom-data/components/__generated__/FieldMappingConfigurationListPaginationQuery.graphql.ts
var node2 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FieldMappingConfigurationListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "FieldMappingConfigurationList_fieldMappingConfigurations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FieldMappingConfigurationListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "IntegrationFieldMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationFieldMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationFieldMappingConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fieldMappingConfigurationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationMappableAction",
                      "kind": "LinkedField",
                      "name": "mappings",
                      "plural": true,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "IntegrationMappable",
                          "kind": "LinkedField",
                          "name": "source",
                          "plural": false,
                          "selections": v5,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "IntegrationMappable",
                          "kind": "LinkedField",
                          "name": "target",
                          "plural": false,
                          "selections": v5,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "FieldMappingConfigurationList_integrationFieldMappings",
          "kind": "LinkedHandle",
          "name": "integrationFieldMappings"
        }
      ]
    },
    "params": {
      "cacheID": "ac87ffb2a135b539af9a4f227f379202",
      "id": null,
      "metadata": {},
      "name": "FieldMappingConfigurationListPaginationQuery",
      "operationKind": "query",
      "text": "query FieldMappingConfigurationListPaginationQuery(\n  $after: String\n  $first: Int = 10\n) {\n  ...FieldMappingConfigurationList_fieldMappingConfigurations_2HEEH6\n}\n\nfragment FieldMappingConfigurationList_fieldMappingConfigurations_2HEEH6 on Query {\n  integrationFieldMappings(first: $first, after: $after, order: [{updatedAt: DESC}]) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        ...FieldMappingConfigurationRow_fieldMappingConfiguration\n        __typename\n      }\n    }\n  }\n}\n\nfragment FieldMappingConfigurationRow_fieldMappingConfiguration on IntegrationFieldMappingConfiguration {\n  id\n  fieldMappingConfigurationId\n  createdAt\n  updatedAt\n  name\n  sourceType\n  targetType\n  mappings {\n    id\n    source {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n    target {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n  }\n}\n"
    }
  };
}();
node2.hash = "f75377917b71902b465aa65fd187e597";
var FieldMappingConfigurationListPaginationQuery_graphql_default = node2;

// src/custom-data/components/__generated__/FieldMappingConfigurationList_fieldMappingConfigurations.graphql.ts
var node3 = /* @__PURE__ */ function() {
  var v0 = [
    "integrationFieldMappings"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": FieldMappingConfigurationListPaginationQuery_graphql_default
      }
    },
    "name": "FieldMappingConfigurationList_fieldMappingConfigurations",
    "selections": [
      {
        "alias": "integrationFieldMappings",
        "args": null,
        "concreteType": "IntegrationFieldMappingsConnection",
        "kind": "LinkedField",
        "name": "__FieldMappingConfigurationList_integrationFieldMappings_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationFieldMappingsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationFieldMappingConfiguration",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FieldMappingConfigurationRow_fieldMappingConfiguration"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node3.hash = "f75377917b71902b465aa65fd187e597";
var FieldMappingConfigurationList_fieldMappingConfigurations_graphql_default = node3;

// src/custom-data/components/FieldMappingConfigurationList.tsx
import { useCallback as useCallback10 } from "react";
import { usePaginationFragment } from "react-relay";
import { EdListHeader, EdTable as EdTable3 } from "shared-ui";

// src/custom-data/components/__generated__/FieldMappingConfigurationRow_fieldMappingConfiguration.graphql.ts
var node4 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FieldMappingConfigurationRow_fieldMappingConfiguration",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fieldMappingConfigurationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationMappableAction",
        "kind": "LinkedField",
        "name": "mappings",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappable",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappable",
            "kind": "LinkedField",
            "name": "target",
            "plural": false,
            "selections": v1,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "IntegrationFieldMappingConfiguration",
    "abstractKey": null
  };
}();
node4.hash = "d25293b3d9ad27d32c6d491b404d9a95";
var FieldMappingConfigurationRow_fieldMappingConfiguration_graphql_default = node4;

// src/custom-data/components/FieldMappingConfigurationRow.tsx
import { useCallback as useCallback9 } from "react";
import { useFragment as useFragment2 } from "react-relay";
import { timeAgo } from "shared-lib";
import { EdActionCell as EdActionCell2, EdColumnCell as EdColumnCell3, EdRow as EdRow3, LinkButton } from "shared-ui";
import { jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var fieldMappingConfiguration = FieldMappingConfigurationRow_fieldMappingConfiguration_graphql_default;
var FieldMappingConfigurationRow = (props) => {
  const data = useFragment2(
    fieldMappingConfiguration,
    props.fieldMappingConfiguration
  );
  const select = useCallback9(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs8(EdRow3, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx10(EdColumnCell3, { children: data.name }),
    /* @__PURE__ */ jsx10(EdColumnCell3, { children: data.sourceType }),
    /* @__PURE__ */ jsx10(EdColumnCell3, { children: data.targetType }),
    /* @__PURE__ */ jsx10(EdColumnCell3, { children: timeAgo(data.createdAt) }),
    /* @__PURE__ */ jsx10(EdColumnCell3, { children: timeAgo(data.updatedAt) }),
    /* @__PURE__ */ jsx10(EdActionCell2, { children: /* @__PURE__ */ jsx10(LinkButton, { label: "Select", clicked: select }) })
  ] });
};
var FieldMappingConfigurationRow_default = FieldMappingConfigurationRow;

// src/custom-data/components/FieldMappingConfigurationList.tsx
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var columns3 = [
  { id: "name", name: "Name" },
  { id: "sourceType", name: "Source Type" },
  { id: "targetType", name: "Target Type" },
  { id: "createdOn", name: "Created On" },
  { id: "updatedOn", name: "Updated On" }
];
var fragment2 = FieldMappingConfigurationList_fieldMappingConfigurations_graphql_default;
var FieldMappingConfigurationList = ({
  onSelect,
  fieldMappingConfigurationsKey
}) => {
  const select = useCallback10((event) => {
    onSelect(event);
  }, []);
  const paging = usePaginationFragment(fragment2, fieldMappingConfigurationsKey);
  const { data } = paging;
  const { integrationFieldMappings } = data;
  const rows = integrationFieldMappings?.edges?.map((e) => {
    return /* @__PURE__ */ jsx11(
      FieldMappingConfigurationRow_default,
      {
        fieldMappingConfiguration: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs9("div", { children: [
    /* @__PURE__ */ jsx11(EdListHeader, { paging }),
    /* @__PURE__ */ jsx11("div", { className: "flex", children: /* @__PURE__ */ jsx11("div", { className: "w-full", children: /* @__PURE__ */ jsx11(EdTable3, { defaultColumns: columns3, rows }) }) })
  ] });
};
var FieldMappingConfigurationList_default = FieldMappingConfigurationList;

// src/custom-data/components/FieldMappingEditor.tsx
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var FieldMappingEditor = ({ mappings }) => {
  const mappingItems = mappings.map((mapping) => {
    return /* @__PURE__ */ jsxs10("div", { className: "flex p-4", children: [
      /* @__PURE__ */ jsx12("div", { children: mapping.source?.label }),
      /* @__PURE__ */ jsx12("div", { children: mapping.target?.label })
    ] }, `${mapping.source}-${mapping.target}`);
  });
  return /* @__PURE__ */ jsx12("div", { children: mappingItems });
};

// src/custom-data/components/__generated__/FieldMappingSelectorQuery.graphql.ts
var node5 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FieldMappingSelectorQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FieldMappingSelectorResults_integrationFieldMappings"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FieldMappingSelectorQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationFieldMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationFieldMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationFieldMappingConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fieldMappingConfigurationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationSystemsType",
                      "kind": "LinkedField",
                      "name": "sourceSystem",
                      "plural": false,
                      "selections": v2,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationSystemsType",
                      "kind": "LinkedField",
                      "name": "targetSystem",
                      "plural": false,
                      "selections": v2,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "FieldMappingSelectorResults_integrationFieldMappings",
          "kind": "LinkedHandle",
          "name": "integrationFieldMappings"
        }
      ]
    },
    "params": {
      "cacheID": "f763af78d4b4efe6b6ea7428914ab493",
      "id": null,
      "metadata": {},
      "name": "FieldMappingSelectorQuery",
      "operationKind": "query",
      "text": "query FieldMappingSelectorQuery(\n  $where: IntegrationFieldMappingConfigurationFilter!\n) {\n  ...FieldMappingSelectorResults_integrationFieldMappings\n}\n\nfragment FieldMappingSelectorResults_integrationFieldMappings on Query {\n  integrationFieldMappings(first: 10, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        fieldMappingConfigurationId\n        name\n        sourceSystem {\n          displayName\n          key\n        }\n        sourceType\n        targetSystem {\n          displayName\n          key\n        }\n        targetType\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node5.hash = "2a9ac38a5be5be3ae03aee93ee6aef27";
var FieldMappingSelectorQuery_graphql_default = node5;

// src/custom-data/components/FieldMappingSelector.tsx
import { useCallback as useCallback12 } from "react";
import { useLazyLoadQuery } from "react-relay";

// src/custom-data/components/__generated__/FieldMappingSelectorResultsQuery.graphql.ts
var node6 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FieldMappingSelectorResultsQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "FieldMappingSelectorResults_integrationFieldMappings"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FieldMappingSelectorResultsQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "IntegrationFieldMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationFieldMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationFieldMappingConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fieldMappingConfigurationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationSystemsType",
                      "kind": "LinkedField",
                      "name": "sourceSystem",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationSystemsType",
                      "kind": "LinkedField",
                      "name": "targetSystem",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "FieldMappingSelectorResults_integrationFieldMappings",
          "kind": "LinkedHandle",
          "name": "integrationFieldMappings"
        }
      ]
    },
    "params": {
      "cacheID": "c2a5bdecaf3ae46a0b3501a848c680ea",
      "id": null,
      "metadata": {},
      "name": "FieldMappingSelectorResultsQuery",
      "operationKind": "query",
      "text": "query FieldMappingSelectorResultsQuery(\n  $after: String\n  $first: Int = 10\n  $where: IntegrationFieldMappingConfigurationFilter\n) {\n  ...FieldMappingSelectorResults_integrationFieldMappings_2HEEH6\n}\n\nfragment FieldMappingSelectorResults_integrationFieldMappings_2HEEH6 on Query {\n  integrationFieldMappings(first: $first, after: $after, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        fieldMappingConfigurationId\n        name\n        sourceSystem {\n          displayName\n          key\n        }\n        sourceType\n        targetSystem {\n          displayName\n          key\n        }\n        targetType\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node6.hash = "d54615c8bbdc1cab1defc18240a78a2e";
var FieldMappingSelectorResultsQuery_graphql_default = node6;

// src/custom-data/components/__generated__/FieldMappingSelectorResults_integrationFieldMappings.graphql.ts
var node7 = /* @__PURE__ */ function() {
  var v0 = [
    "integrationFieldMappings"
  ], v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": FieldMappingSelectorResultsQuery_graphql_default
      }
    },
    "name": "FieldMappingSelectorResults_integrationFieldMappings",
    "selections": [
      {
        "alias": "integrationFieldMappings",
        "args": null,
        "concreteType": "IntegrationFieldMappingsConnection",
        "kind": "LinkedField",
        "name": "__FieldMappingSelectorResults_integrationFieldMappings_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationFieldMappingsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationFieldMappingConfiguration",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fieldMappingConfigurationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationSystemsType",
                    "kind": "LinkedField",
                    "name": "sourceSystem",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationSystemsType",
                    "kind": "LinkedField",
                    "name": "targetSystem",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "targetType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node7.hash = "d54615c8bbdc1cab1defc18240a78a2e";
var FieldMappingSelectorResults_integrationFieldMappings_graphql_default = node7;

// src/custom-data/components/FieldMappingSelectorResults.tsx
import { useCallback as useCallback11, useState as useState6 } from "react";
import { usePaginationFragment as usePaginationFragment2 } from "react-relay";
import {
  Button as Button6,
  ButtonList as ButtonList5,
  EdListHeader as EdListHeader2,
  SelectMenu as SelectMenu4
} from "shared-ui";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var fragment3 = FieldMappingSelectorResults_integrationFieldMappings_graphql_default;
var FieldMappingSelectorResultsResults = ({
  integrationFieldMappingsKey,
  onSelect
}) => {
  const select = useCallback11((event) => {
    onSelect(event);
  }, []);
  const [current, setCurrent] = useState6(null);
  const onSetCurrent = useCallback11(
    (item) => {
      setCurrent(item);
    },
    [current]
  );
  const paging = usePaginationFragment2(fragment3, integrationFieldMappingsKey);
  const { data } = paging;
  const { integrationFieldMappings } = data;
  const mappings = integrationFieldMappings?.edges;
  let results;
  if (mappings && mappings.length > 0) {
    const items = mappings.map((e) => {
      return {
        id: e.node.fieldMappingConfigurationId,
        name: e.node.name
      };
    });
    let selectedMapping;
    if (current) {
      const mapping = mappings.find(
        (m) => m.node.fieldMappingConfigurationId === current.id
      );
      if (mapping) {
        selectedMapping = /* @__PURE__ */ jsxs11("div", { className: "my-2 border px-4 py-2", children: [
          /* @__PURE__ */ jsx13("div", { className: "text-info-900 mb-2 border-b border-gray-100 py-2 font-medium", children: mapping.node.name }),
          /* @__PURE__ */ jsxs11("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ jsx13("div", { className: "w-12 font-medium text-gray-500", children: "Source" }),
            /* @__PURE__ */ jsx13("div", { className: "w-16", children: mapping.node.sourceSystem.displayName }),
            /* @__PURE__ */ jsx13("div", { className: "text-info-500 font-medium", children: mapping.node.sourceType })
          ] }),
          /* @__PURE__ */ jsxs11("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ jsx13("div", { className: "w-12 font-medium text-gray-500", children: "Target" }),
            /* @__PURE__ */ jsx13("div", { className: "w-16", children: mapping.node.targetSystem.displayName }),
            /* @__PURE__ */ jsx13("div", { className: "text-info-500 font-medium", children: mapping.node.targetType })
          ] }),
          /* @__PURE__ */ jsxs11(ButtonList5, { children: [
            /* @__PURE__ */ jsx13(
              Button6,
              {
                "aria-label": "Cancel",
                color: "gray",
                clicked: () => setCurrent(null),
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ jsx13(Button6, { "aria-label": "Use", clicked: () => select(current), children: "Use" })
          ] })
        ] }, mapping.node.id);
      }
    }
    results = /* @__PURE__ */ jsxs11("div", { children: [
      /* @__PURE__ */ jsx13(EdListHeader2, { paging }),
      selectedMapping ? null : /* @__PURE__ */ jsx13(
        SelectMenu4,
        {
          title: "Select Mapping",
          items,
          onChange: onSetCurrent,
          value: current
        }
      ),
      selectedMapping ? /* @__PURE__ */ jsx13("div", { className: "mt-4", children: selectedMapping }) : null
    ] });
  } else {
    results = /* @__PURE__ */ jsx13("div", { children: /* @__PURE__ */ jsx13("div", { className: "text-info-500 text-xl font-medium", children: "No suitable custom field mappings are available" }) });
  }
  return /* @__PURE__ */ jsx13("div", { children: results });
};
var FieldMappingSelectorResults_default = FieldMappingSelectorResultsResults;

// src/custom-data/components/FieldMappingSelector.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var graphqlQuery = FieldMappingSelectorQuery_graphql_default;
var FieldMappingSelector = ({
  onSelect,
  sourceSystem,
  sourceType,
  targetSystem,
  targetType
}) => {
  const select = useCallback12((event) => {
    onSelect(event);
  }, []);
  const where = {};
  if (sourceType) {
    where.sourceSystem = { eq: sourceSystem };
  }
  if (sourceType) {
    where.sourceType = { eq: sourceType };
  }
  if (targetSystem) {
    where.targetSystem = { eq: targetSystem };
  }
  if (targetType) {
    where.targetType = { eq: targetType };
  }
  const query = useLazyLoadQuery(
    graphqlQuery,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx14(
    FieldMappingSelectorResults_default,
    {
      integrationFieldMappingsKey: query,
      onSelect: select
    }
  );
};
var FieldMappingSelector_default = FieldMappingSelector;

// src/custom-data/mutations/field-mapping-config/__generated__/CreateFieldMappingConfigMutation.graphql.ts
var node8 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfFieldMappingConfiguration",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationFieldMappingConfiguration",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fieldMappingConfigurationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationSystemsType",
            "kind": "LinkedField",
            "name": "sourceSystem",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationSystemsType",
            "kind": "LinkedField",
            "name": "targetSystem",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CreateFieldMappingConfigMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "IntegrationsCreateFieldMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsCreateFieldMapping",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CreateFieldMappingConfigMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "IntegrationsCreateFieldMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsCreateFieldMapping",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "7c333d993c0da71f79781b47f4bd990f",
      "id": null,
      "metadata": {},
      "name": "CreateFieldMappingConfigMutation",
      "operationKind": "mutation",
      "text": "mutation CreateFieldMappingConfigMutation(\n  $input: IntegrationsCreateFieldMappingInput!\n) {\n  integrationsCreateFieldMapping(input: $input) {\n    payload {\n      __typename\n      cursor\n      node {\n        id\n        fieldMappingConfigurationId\n        createdAt\n        updatedAt\n        name\n        sourceSystem {\n          displayName\n          key\n        }\n        sourceType\n        targetSystem {\n          displayName\n          key\n        }\n        targetType\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node8.hash = "de8c009399e918e4ce40f68f77b9e20a";
var CreateFieldMappingConfigMutation_graphql_default = node8;

// src/custom-data/mutations/field-mapping-config/CreateFieldMappingConfigMutation.ts
import { useAsyncMutation } from "shared-lib";
var mutationDef = CreateFieldMappingConfigMutation_graphql_default;
function useCreateFieldMappingConfig() {
  const [commit2, isBusy] = useAsyncMutation(mutationDef);
  return [commit2, isBusy];
}

// src/custom-data/mutations/field-mapping-config/__generated__/SaveFieldMappingConfigMutation.graphql.ts
var node9 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v6 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    v5
  ], v7 = [
    v5,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ], v8 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfFieldMappingConfiguration",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationFieldMappingConfiguration",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationSystemsType",
            "kind": "LinkedField",
            "name": "sourceSystem",
            "plural": false,
            "selections": v6,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationSystemsType",
            "kind": "LinkedField",
            "name": "targetSystem",
            "plural": false,
            "selections": v6,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappableAction",
            "kind": "LinkedField",
            "name": "mappings",
            "plural": true,
            "selections": [
              v4,
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationMappable",
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": v7,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationMappable",
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": v7,
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SaveFieldMappingConfigMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "IntegrationsSaveFieldMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsSaveFieldMapping",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SaveFieldMappingConfigMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "IntegrationsSaveFieldMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsSaveFieldMapping",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "67701bb9c589b682ade17af74b78b04c",
      "id": null,
      "metadata": {},
      "name": "SaveFieldMappingConfigMutation",
      "operationKind": "mutation",
      "text": "mutation SaveFieldMappingConfigMutation(\n  $input: IntegrationsSaveFieldMappingInput!\n) {\n  integrationsSaveFieldMapping(input: $input) {\n    payload {\n      __typename\n      cursor\n      node {\n        id\n        createdAt\n        updatedAt\n        name\n        sourceSystem {\n          displayName\n          key\n        }\n        sourceType\n        targetSystem {\n          displayName\n          key\n        }\n        targetType\n        mappings {\n          id\n          source {\n            key\n            label\n            dataTypeKey\n            processorTypeKey\n            value\n          }\n          target {\n            key\n            label\n            dataTypeKey\n            processorTypeKey\n            value\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node9.hash = "3cba650a6b211fc993596e4b31663fe9";
var SaveFieldMappingConfigMutation_graphql_default = node9;

// src/custom-data/mutations/field-mapping-config/SaveFieldMappingConfigMutation.ts
import { useAsyncMutation as useAsyncMutation2 } from "shared-lib";
var mutation = SaveFieldMappingConfigMutation_graphql_default;
function useSaveFieldMappingConfig() {
  const [commit2, isBusy] = useAsyncMutation2(mutation);
  return [commit2, isBusy];
}
var SaveFieldMappingConfigMutation_default = useSaveFieldMappingConfig;

// src/elevate/components/__generated__/VacancyDetailsData.graphql.ts
var node10 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyDetailsData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdByAccountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedByAccountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elevateEmployerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalVacancyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProperties",
      "storageKey": null
    }
  ],
  "type": "IntegrationsVacancy",
  "abstractKey": null
};
node10.hash = "506fe434362f53e7c0bbe1f40961a1b6";
var VacancyDetailsData_graphql_default = node10;

// src/elevate/components/VacancyDetails.tsx
import { Fragment as Fragment3 } from "react";
import { useFragment as useFragment3 } from "react-relay";
import { AuditFields as AuditFields2, DescriptionItem as DescriptionItem2, DescriptionList as DescriptionList2 } from "shared-ui";
import { jsx as jsx15, jsxs as jsxs12 } from "react/jsx-runtime";
var fragment4 = VacancyDetailsData_graphql_default;
var VacancyDetails = ({ vacancy }) => {
  const data = useFragment3(fragment4, vacancy);
  return /* @__PURE__ */ jsx15(
    DescriptionList2,
    {
      heading: /* @__PURE__ */ jsx15("div", { className: "flex space-x-2", children: /* @__PURE__ */ jsx15("span", { className: "text-info-600", children: "Integration Vacancy" }) }),
      items: /* @__PURE__ */ jsxs12(Fragment3, { children: [
        /* @__PURE__ */ jsx15("div", { className: "p-4", children: /* @__PURE__ */ jsx15(
          AuditFields2,
          {
            createdOn: data.createdAt,
            updatedOn: data.updatedAt
          }
        ) }),
        /* @__PURE__ */ jsx15(DescriptionItem2, { label: "Status", children: /* @__PURE__ */ jsx15("div", { children: data.status }) }),
        /* @__PURE__ */ jsx15(DescriptionItem2, { label: "External Status", children: /* @__PURE__ */ jsx15("div", { children: data.externalStatus }) })
      ] })
    }
  );
};

// src/elevate/components/__generated__/VacancyContainerQuery.graphql.ts
var node11 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "externalVacancyId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "externalVacancyId"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyContainerQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "IntegrationsVacancy",
          "kind": "LinkedField",
          "name": "integrationVacancyByExternalId",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyDetailsData"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyContainerQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "IntegrationsVacancy",
          "kind": "LinkedField",
          "name": "integrationVacancyByExternalId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdByAccountType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedByAccountType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "elevateEmployerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalVacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customProperties",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8fcf6ee242bca5e9e4d101a703a67e83",
      "id": null,
      "metadata": {},
      "name": "VacancyContainerQuery",
      "operationKind": "query",
      "text": "query VacancyContainerQuery(\n  $externalVacancyId: String!\n) {\n  vacancy: integrationVacancyByExternalId(id: $externalVacancyId) {\n    ...VacancyDetailsData\n    id\n  }\n}\n\nfragment VacancyDetailsData on IntegrationsVacancy {\n  id\n  createdByAccountType\n  createdById\n  createdAt\n  updatedByAccountType\n  updatedById\n  updatedAt\n  vacancyId\n  elevateEmployerId\n  externalStatus\n  externalVacancyId\n  integrationType\n  status\n  customProperties\n}\n"
    }
  };
}();
node11.hash = "de321d22c4773f3798f3cc445c3b24d6";
var VacancyContainerQuery_graphql_default = node11;

// src/elevate/components/VacancyContainer.tsx
import { Suspense } from "react";
import { useLazyLoadQuery as useLazyLoadQuery2 } from "react-relay";
import { EdSkeleton } from "shared-ui";
import { jsx as jsx16 } from "react/jsx-runtime";
var graphqlQuery2 = VacancyContainerQuery_graphql_default;
var VacancyContainer = ({
  noVacancyContent,
  externalVacancyId
}) => {
  const query = useLazyLoadQuery2(
    graphqlQuery2,
    { externalVacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { vacancy } = query;
  return /* @__PURE__ */ jsx16(Suspense, { fallback: /* @__PURE__ */ jsx16(EdSkeleton, {}), children: vacancy ? /* @__PURE__ */ jsx16(VacancyDetails, { vacancy }) : /* @__PURE__ */ jsx16("div", { children: noVacancyContent }) });
};

// src/employer-mappings/components/__generated__/EmployerMappingListPaginationQuery.graphql.ts
var node12 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerMappingListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "EmployerMappingList_employerMappings"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerMappingListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "IntegrationEmployerMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationEmployerMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationEmployerMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationsEmployerMapping",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerMappingId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "integrationType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "elevateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "EmployerMappingList_integrationEmployerMappings",
          "kind": "LinkedHandle",
          "name": "integrationEmployerMappings"
        }
      ]
    },
    "params": {
      "cacheID": "2f92f78f0c8fcbadf6592f0b4996d3de",
      "id": null,
      "metadata": {},
      "name": "EmployerMappingListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerMappingListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [IntegrationsEmployerMappingSort!]\n  $where: IntegrationsEmployerMappingFilter\n) {\n  ...EmployerMappingList_employerMappings_2HEEH6\n}\n\nfragment EmployerMappingList_employerMappings_2HEEH6 on Query {\n  integrationEmployerMappings(first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerMappingId\n        createdAt\n        updatedAt\n        integrationType\n        elevateId\n        externalId\n        ...EmployerMappingRow_employerMapping\n        __typename\n      }\n    }\n  }\n}\n\nfragment EmployerMappingRow_employerMapping on IntegrationsEmployerMapping {\n  id\n  createdAt\n  updatedAt\n  integrationType\n  employerMappingId\n  elevateId\n  externalId\n}\n"
    }
  };
}();
node12.hash = "0a58d0f513f881b1858fee05700bb0e3";
var EmployerMappingListPaginationQuery_graphql_default = node12;

// src/employer-mappings/components/__generated__/EmployerMappingList_employerMappings.graphql.ts
var node13 = /* @__PURE__ */ function() {
  var v0 = [
    "integrationEmployerMappings"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerMappingListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerMappingList_employerMappings",
    "selections": [
      {
        "alias": "integrationEmployerMappings",
        "args": null,
        "concreteType": "IntegrationEmployerMappingsConnection",
        "kind": "LinkedField",
        "name": "__EmployerMappingList_integrationEmployerMappings_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationEmployerMappingsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationsEmployerMapping",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerMappingId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integrationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "elevateId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalId",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerMappingRow_employerMapping"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node13.hash = "0a58d0f513f881b1858fee05700bb0e3";
var EmployerMappingList_employerMappings_graphql_default = node13;

// src/employer-mappings/components/EmployerMappingList.tsx
import { useCallback as useCallback14, useEffect as useEffect4 } from "react";
import { usePaginationFragment as usePaginationFragment3 } from "react-relay";
import {
  EdListHeader as EdListHeader3,
  EdTable as EdTable4,
  LinkButton as LinkButton3,
  selectColumn,
  SortDir
} from "shared-ui";
import { useToggle } from "shared-lib";

// src/employer-mappings/components/__generated__/EmployerMappingRow_employerMapping.graphql.ts
var node14 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerMappingRow_employerMapping",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerMappingId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elevateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "type": "IntegrationsEmployerMapping",
  "abstractKey": null
};
node14.hash = "0a9551e0d3e9dd1a547cc093404de50a";
var EmployerMappingRow_employerMapping_graphql_default = node14;

// src/employer-mappings/components/EmployerMappingRow.tsx
import { useCallback as useCallback13 } from "react";
import { useFragment as useFragment4 } from "react-relay";
import { EdActionCell as EdActionCell3, EdColumnCell as EdColumnCell4, EdRow as EdRow4, LinkButton as LinkButton2 } from "shared-ui";
import { formatDateTime } from "shared-lib";
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var employerMapping = EmployerMappingRow_employerMapping_graphql_default;
var EmployerMappingRow = (props) => {
  const data = useFragment4(employerMapping, props.employerMapping);
  const select = useCallback13(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs13(EdRow4, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx17(EdColumnCell4, { children: formatDateTime(data.createdAt) }),
    /* @__PURE__ */ jsx17(EdColumnCell4, { children: formatDateTime(data.updatedAt) }),
    /* @__PURE__ */ jsx17(EdColumnCell4, { children: data.integrationType }),
    /* @__PURE__ */ jsx17(EdColumnCell4, { children: data.elevateId }),
    /* @__PURE__ */ jsx17(EdColumnCell4, { children: data.externalId }),
    /* @__PURE__ */ jsx17(EdActionCell3, { children: /* @__PURE__ */ jsx17(LinkButton2, { label: "Select", clicked: select }) })
  ] });
};
var EmployerMappingRow_default = EmployerMappingRow;

// src/employer-mappings/components/EmployerMappingList.tsx
import { jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var defaultColumns = [
  {
    id: "createdOn",
    name: "Created",
    sort: true,
    sortValue: SortDir.Desc
  },
  {
    id: "updatedOn",
    name: "Last Update",
    sort: true,
    sortValue: SortDir.Desc
  },
  { id: "integrationType", name: "Integration Type" },
  { id: "elevateId", name: "Elevate Id" },
  { id: "externalId", name: "External Id" }
];
var fragment5 = EmployerMappingList_employerMappings_graphql_default;
var EmployerMappingList = ({
  onSelect,
  employerMappingsKey
}) => {
  const [showNotActive, toggleShowNotActive] = useToggle(false);
  const rowSelected = useCallback14(
    (e) => {
      onSelect({
        id: e.employerMappingId
      });
    },
    []
  );
  const paging = usePaginationFragment3(fragment5, employerMappingsKey);
  function fetch(refetchParameters) {
    refetch(refetchParameters, {
      fetchPolicy: "network-only",
      onComplete: (e) => {
        if (e) {
          console.error(e);
        } else {
          console.log("changed sort on job order list");
        }
      }
    });
  }
  useEffect4(() => {
    let params;
    if (showNotActive) {
      params = {
        first: 10,
        where: {
          or: [{ isActive: { eq: true } }, { isActive: { eq: false } }]
        }
      };
    } else {
      params = {
        first: 10,
        where: {
          or: [{ isActive: { eq: true } }]
        }
      };
    }
    fetch(params);
  }, [showNotActive]);
  const onSortChanged = useCallback14((columns5) => {
    const hasOrderBy = columns5.filter((c) => c.sort && c.sortValue).length > 0;
    if (hasOrderBy === false) {
      return;
    }
    const where = {
      or: [{ isActive: { eq: true } }, { isActive: { eq: false } }]
    };
    const orderBy = [];
    const createdAt = selectColumn("createdAt", columns5);
    if (createdAt) {
      orderBy.push({ createdAt });
    }
    const updatedAt = selectColumn("updatedAt", columns5);
    if (updatedAt) {
      orderBy.push({ updatedAt });
    }
    let refetchParameters;
    if (showNotActive) {
      refetchParameters = { first: 10, order: orderBy, where };
    } else {
      refetchParameters = { first: 10, order: orderBy };
    }
    fetch(refetchParameters);
  }, []);
  const { data, refetch } = paging;
  const rows = data.integrationEmployerMappings?.edges?.map((e) => {
    return /* @__PURE__ */ jsx18(
      EmployerMappingRow_default,
      {
        employerMapping: e.node,
        selected: rowSelected
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs14("div", { children: [
    /* @__PURE__ */ jsx18(
      EdListHeader3,
      {
        total: data.integrationEmployerMappings?.totalCount,
        paging,
        content: /* @__PURE__ */ jsx18("div", { className: "flex items-center justify-end p-2", children: /* @__PURE__ */ jsx18(LinkButton3, { clicked: toggleShowNotActive, children: showNotActive ? "Hide Not Active" : "Include Not Active" }) })
      }
    ),
    /* @__PURE__ */ jsx18("div", { className: "flex", children: /* @__PURE__ */ jsx18("div", { className: "w-full", children: /* @__PURE__ */ jsx18(
      EdTable4,
      {
        defaultColumns,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};

// src/employer-mappings/components/__generated__/EmployerMappingEditFormQuery.graphql.ts
var node15 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    {
      "alias": "mapping",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "IntegrationsEmployerMapping",
      "kind": "LinkedField",
      "name": "integrationEmployerMappingById",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "integrationType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "elevateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerMappingId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdByAccountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdById",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedByAccountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedById",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "employer",
          "plural": false,
          "selections": [
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webSite",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerMappingEditFormQuery",
      "selections": v2,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerMappingEditFormQuery",
      "selections": v2
    },
    "params": {
      "cacheID": "09aaeeba686c1e89bda3f0aa15e3828f",
      "id": null,
      "metadata": {},
      "name": "EmployerMappingEditFormQuery",
      "operationKind": "query",
      "text": "query EmployerMappingEditFormQuery(\n  $id: UUID!\n) {\n  mapping: integrationEmployerMappingById(id: $id) {\n    id\n    integrationType\n    externalId\n    elevateId\n    isActive\n    employerMappingId\n    createdAt\n    createdByAccountType\n    createdById\n    updatedAt\n    updatedByAccountType\n    updatedById\n    employer {\n      id\n      code\n      entityId\n      employerId\n      name\n      slug\n      webSite\n    }\n  }\n}\n"
    }
  };
}();
node15.hash = "4829e51af5c3b68f8d88a635b850a93b";
var EmployerMappingEditFormQuery_graphql_default = node15;

// src/employer-mappings/components/EmployerMappingEditForm.tsx
import { useCallback as useCallback15 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery3, useRelayEnvironment } from "react-relay";
import { useForm as useForm3 } from "react-hook-form";
import * as zod from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { createClientMutationId } from "shared-lib";
import {
  Button as Button7,
  ButtonList as ButtonList6,
  CheckboxInput,
  FormInput as FormInput2,
  SelectMenuInput
} from "shared-ui";
import { EmployerSearchBoxInput } from "feature-employer-accounts";

// src/employer-mappings/lib/IntegrationTypes.ts
var IntegrationTypes = /* @__PURE__ */ ((IntegrationTypes2) => {
  IntegrationTypes2["ACCESS_GROUP"] = "ACCESS_GROUP";
  IntegrationTypes2["BULLHORN"] = "BULLHORN";
  IntegrationTypes2["BOOMI"] = "BOOMI";
  IntegrationTypes2["ELEVATE"] = "ELEVATE";
  return IntegrationTypes2;
})(IntegrationTypes || {});
var IntegrationTypesList = [
  { id: "ACCESS_GROUP" /* ACCESS_GROUP */, name: "ACCESS_GROUP" /* ACCESS_GROUP */ },
  { id: "BULLHORN" /* BULLHORN */, name: "BULLHORN" /* BULLHORN */ },
  { id: "BOOMI" /* BOOMI */, name: "BOOMI" /* BOOMI */ },
  { id: "ELEVATE" /* ELEVATE */, name: "ELEVATE" /* ELEVATE */ }
];
function selectIntegrationTypeListItem(value) {
  if (value === null || value === void 0) {
    return null;
  }
  const item = IntegrationTypesList.find(
    (i) => i.id.toLowerCase() === value.toLowerCase()
  );
  if (item) {
    return item;
  }
  return null;
}
function parseIntegrationTypes(value) {
  switch (value.toUpperCase()) {
    case "BOOMI" /* BOOMI */:
      return "BOOMI" /* BOOMI */;
    case "ACCESS_GROUP" /* ACCESS_GROUP */:
      return "ACCESS_GROUP" /* ACCESS_GROUP */;
    case "ELEVATE" /* ELEVATE */:
      return "ELEVATE" /* ELEVATE */;
    case "BULLHORN" /* BULLHORN */:
      return "BULLHORN" /* BULLHORN */;
    default:
      throw new Error("Unknown IntegrationTypes");
  }
}

// src/employer-mappings/mutations/__generated__/SetEmployerMappingMutation.graphql.ts
var node16 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerMapping",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationsEmployerMapping",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerMappingId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "integrationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "elevateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SetEmployerMappingMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "IntegrationsSetEmployerMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsSetEmployerMapping",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SetEmployerMappingMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "IntegrationsSetEmployerMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsSetEmployerMapping",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6b26ac9e26826a09b5451ad159d456e5",
      "id": null,
      "metadata": {},
      "name": "SetEmployerMappingMutation",
      "operationKind": "mutation",
      "text": "mutation SetEmployerMappingMutation(\n  $input: IntegrationsSetEmployerMappingInput!\n) {\n  integrationsSetEmployerMapping(input: $input) {\n    payload {\n      __typename\n      cursor\n      node {\n        id\n        employerMappingId\n        createdAt\n        updatedAt\n        integrationType\n        elevateId\n        externalId\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node16.hash = "b237a846ee12014a4a7581e5b275ec5c";
var SetEmployerMappingMutation_graphql_default = node16;

// src/employer-mappings/mutations/SetEmployerMappingMutation.ts
import { createConnectedCommitMutation } from "shared-lib";
var mutation2 = SetEmployerMappingMutation_graphql_default;
var commit = createConnectedCommitMutation(mutation2);
var SetEmployerMappingMutation_default = { commit };

// src/employer-mappings/components/EmployerMappingEditForm.tsx
import { jsx as jsx19, jsxs as jsxs15 } from "react/jsx-runtime";
var integrationTypes = Object.values(IntegrationTypes);
var FormSchema = zod.object({
  elevateId: zod.string().nonempty(),
  externalId: zod.string().nonempty(),
  integrationType: zod.enum(integrationTypes),
  isActive: zod.boolean(),
  clientMutationId: zod.string().default(createClientMutationId())
});
var graphqlQuery3 = EmployerMappingEditFormQuery_graphql_default;
var EmployerMappingEditForm = ({
  id,
  onDone
}) => {
  const query = useLazyLoadQuery3(
    graphqlQuery3,
    { id },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { mapping } = query;
  const environment = useRelayEnvironment();
  const defaultValues = {
    elevateId: mapping.elevateId,
    externalId: mapping.externalId,
    integrationType: parseIntegrationTypes(mapping.integrationType),
    isActive: mapping.isActive,
    clientMutationId: createClientMutationId()
  };
  const { register, handleSubmit, formState, control } = useForm3({
    resolver: zodResolver(FormSchema),
    defaultValues
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data) => onSaveConfig(isValid, data));
  const onSaveConfig = useCallback15(
    (isValid2, form) => {
      if (!isValid2 || form.integrationType === void 0 || form.isActive === void 0) {
        return;
      }
      const input = {
        elevateId: form.elevateId,
        externalId: form.externalId,
        integrationType: form.integrationType,
        isActive: form.isActive,
        clientMutationId: createClientMutationId()
      };
      SetEmployerMappingMutation_default.commit(
        environment,
        input,
        "EmployerMappingList_integrationEmployerMappings",
        () => {
          onDone();
        }
      );
    },
    [environment, onDone]
  );
  if (!mapping) {
    return /* @__PURE__ */ jsx19("div", { children: "Loading Mapping" });
  }
  const selectedIntegrationType = selectIntegrationTypeListItem(
    mapping.integrationType
  );
  return /* @__PURE__ */ jsx19("form", { onSubmit, children: /* @__PURE__ */ jsx19("div", { className: "mt-4 shadow sm:rounded-md md:w-3/4 lg:w-1/2", children: /* @__PURE__ */ jsxs15("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    /* @__PURE__ */ jsxs15("div", { children: [
      /* @__PURE__ */ jsx19(
        EmployerSearchBoxInput,
        {
          control,
          defaultValue: mapping.employer,
          name: "elevateId"
        }
      ),
      errors.elevateId && /* @__PURE__ */ jsx19("p", { children: errors.elevateId.message })
    ] }),
    /* @__PURE__ */ jsxs15("div", { children: [
      /* @__PURE__ */ jsx19("label", { children: "External Id" }),
      /* @__PURE__ */ jsx19(
        FormInput2,
        {
          type: "text",
          placeholder: " Elevate Employer Id ",
          defaultValue: mapping.externalId || "",
          name: "externalId",
          required: true,
          register
        }
      ),
      errors.externalId && /* @__PURE__ */ jsx19("p", { children: errors.externalId.message })
    ] }),
    /* @__PURE__ */ jsxs15("div", { children: [
      /* @__PURE__ */ jsx19(
        CheckboxInput,
        {
          label: /* @__PURE__ */ jsx19("span", { children: "Is Active" }),
          defaultChecked: mapping.isActive ?? false,
          name: "isActive",
          control,
          disabled: false
        }
      ),
      errors.isActive && /* @__PURE__ */ jsx19("p", { children: errors.isActive.message })
    ] }),
    /* @__PURE__ */ jsxs15("div", { children: [
      /* @__PURE__ */ jsx19("label", { children: "Integration Type" }),
      /* @__PURE__ */ jsx19(
        SelectMenuInput,
        {
          name: "integrationType",
          title: "Integration Type",
          control,
          disabled: false,
          items: IntegrationTypesList,
          selectedItem: selectedIntegrationType
        }
      ),
      errors.integrationType && /* @__PURE__ */ jsx19("p", { children: errors.integrationType.message })
    ] }),
    /* @__PURE__ */ jsx19(ButtonList6, { children: /* @__PURE__ */ jsx19(Button7, { disabled: !isValid, color: "primary", type: "submit", children: "Save" }) })
  ] }) }) });
};

// src/employer-mappings/components/EmployerMappingNewForm.tsx
import { useCallback as useCallback16 } from "react";
import { useRelayEnvironment as useRelayEnvironment2 } from "react-relay";
import { useForm as useForm4 } from "react-hook-form";
import * as zod2 from "zod";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import { createClientMutationId as createClientMutationId2 } from "shared-lib";
import { Button as Button8, ButtonList as ButtonList7, FormInput as FormInput3, SelectMenu as SelectMenu5 } from "shared-ui";
import { EmployerSearchBoxInput as EmployerSearchBoxInput2 } from "feature-employer-accounts";
import { jsx as jsx20, jsxs as jsxs16 } from "react/jsx-runtime";
var integrationTypes2 = Object.values(IntegrationTypes);
var FormSchema2 = zod2.object({
  elevateId: zod2.string().nonempty(),
  externalId: zod2.string().nonempty(),
  integrationType: zod2.enum(integrationTypes2),
  isActive: zod2.boolean(),
  clientMutationId: zod2.string().default(createClientMutationId2())
});
var EmployerMappingNewForm = ({
  onDone,
  onCancel
}) => {
  const environment = useRelayEnvironment2();
  const { register, handleSubmit, formState, setValue, control } = useForm4({
    resolver: zodResolver2(FormSchema2)
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data) => onSaveConfig(isValid, data));
  const onSaveConfig = useCallback16((isValid2, form) => {
    if (!isValid2 || form.integrationType === void 0 || form.isActive === void 0) {
      return;
    }
    const input = {
      elevateId: form.elevateId,
      externalId: form.externalId,
      integrationType: form.integrationType,
      isActive: form.isActive,
      clientMutationId: createClientMutationId2()
    };
    SetEmployerMappingMutation_default.commit(
      environment,
      input,
      "EmployerMappingList_integrationEmployerMappings",
      ({ integrationsSetEmployerMapping }) => {
        if (integrationsSetEmployerMapping.employerMapping && integrationsSetEmployerMapping.employerMapping.node) {
          onDone(
            integrationsSetEmployerMapping.employerMapping.node.employerMappingId
          );
        }
      }
    );
  }, []);
  return /* @__PURE__ */ jsx20("form", { onSubmit, children: /* @__PURE__ */ jsx20("div", { className: "mt-4 shadow sm:rounded-md md:w-3/4 lg:w-1/2", children: /* @__PURE__ */ jsxs16("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    /* @__PURE__ */ jsxs16("div", { children: [
      /* @__PURE__ */ jsx20(
        EmployerSearchBoxInput2,
        {
          control,
          defaultValue: null,
          name: "elevateId"
        }
      ),
      errors.elevateId && /* @__PURE__ */ jsx20("p", { children: errors.elevateId.message })
    ] }),
    /* @__PURE__ */ jsxs16("div", { children: [
      /* @__PURE__ */ jsx20("label", { children: "External Id" }),
      /* @__PURE__ */ jsx20(
        FormInput3,
        {
          type: "text",
          placeholder: " Elevate Employer Id ",
          defaultValue: "",
          name: "externalId",
          required: true,
          register
        }
      ),
      errors.externalId && /* @__PURE__ */ jsx20("p", { children: errors.externalId.message })
    ] }),
    /* @__PURE__ */ jsxs16("div", { children: [
      /* @__PURE__ */ jsx20("label", { children: "Is Active" }),
      /* @__PURE__ */ jsx20(
        FormInput3,
        {
          type: "checkbox",
          placeholder: " Is Active ",
          defaultValue: true.toString(),
          name: "isActive",
          required: true,
          register
        }
      ),
      errors.isActive && /* @__PURE__ */ jsx20("p", { children: errors.isActive.message })
    ] }),
    /* @__PURE__ */ jsxs16("div", { children: [
      /* @__PURE__ */ jsx20("label", { children: "Integration Type" }),
      /* @__PURE__ */ jsx20(
        SelectMenu5,
        {
          title: "Integration Type",
          items: IntegrationTypesList,
          onChange: (item) => {
            const integrationType = parseIntegrationTypes(
              item.id
            );
            setValue("integrationType", integrationType, {
              shouldValidate: true
            });
          },
          value: null
        }
      )
    ] }),
    /* @__PURE__ */ jsx20("div", { className: "mx-4", children: /* @__PURE__ */ jsx20(ButtonList7, { children: /* @__PURE__ */ jsx20(Button8, { disabled: !isValid, color: "primary", type: "submit", children: "Create" }) }) })
  ] }) }) });
};

// src/logging/components/__generated__/EventLogItem_eventLogItem.graphql.ts
var node17 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventLogItem_eventLogItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogSourceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogMessage",
      "storageKey": null
    }
  ],
  "type": "IntegrationEventLogItem",
  "abstractKey": null
};
node17.hash = "7a84f8456ab56ca6ab7cb06d8628858d";
var EventLogItem_eventLogItem_graphql_default = node17;

// src/logging/components/EventLogItem.tsx
import { Fragment as Fragment4 } from "react";
import { useFragment as useFragment5 } from "react-relay";
import {
  AuditFields as AuditFields3,
  DescriptionItem as DescriptionItem3,
  DescriptionList as DescriptionList3,
  LinkButton as LinkButton4
} from "shared-ui";
import { jsx as jsx21, jsxs as jsxs17 } from "react/jsx-runtime";
var fragment6 = EventLogItem_eventLogItem_graphql_default;
var EventLogItem = ({
  eventLogItem,
  onBack
}) => {
  const data = useFragment5(fragment6, eventLogItem);
  return /* @__PURE__ */ jsx21("div", { children: /* @__PURE__ */ jsx21("div", { className: "flex", children: /* @__PURE__ */ jsx21(
    DescriptionList3,
    {
      classes: "w-full",
      heading: /* @__PURE__ */ jsxs17("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx21("span", { className: "text-info-600", children: "User Event Log" }),
        /* @__PURE__ */ jsx21(LinkButton4, { label: "Back", clicked: onBack })
      ] }),
      description: /* @__PURE__ */ jsx21("div", { className: "mt-4", children: /* @__PURE__ */ jsx21(AuditFields3, { createdOn: data.createdAt }) }),
      items: /* @__PURE__ */ jsxs17(Fragment4, { children: [
        /* @__PURE__ */ jsx21(DescriptionItem3, { label: "Type", children: data.eventLogType }),
        /* @__PURE__ */ jsx21(DescriptionItem3, { label: "Level", children: data.eventLogLevel }),
        /* @__PURE__ */ jsx21(DescriptionItem3, { label: "Title", children: data.eventLogTitle }),
        /* @__PURE__ */ jsxs17("div", { className: "py-4 sm:px-6 sm:py-5", children: [
          /* @__PURE__ */ jsx21("div", { className: "pb-2 text-sm font-medium text-gray-600", children: "Message" }),
          /* @__PURE__ */ jsx21("div", { className: "prose mt-2 rounded-md border bg-gray-100 p-2 text-gray-900", children: data.eventLogMessage })
        ] })
      ] })
    }
  ) }) });
};

// src/logging/components/__generated__/EventLogListPaginationQuery.graphql.ts
var node18 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {},
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EventLogListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "EventLogList_eventLogItems"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EventLogListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v4,
          "concreteType": "IntegrationEventLogItemsConnection",
          "kind": "LinkedField",
          "name": "integrationEventLogItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationEventLogItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationEventLogItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogSourceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogLevel",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "EventLogList_integrationEventLogItems",
          "kind": "LinkedHandle",
          "name": "integrationEventLogItems"
        }
      ]
    },
    "params": {
      "cacheID": "586e957b2db1c5b03933f953d97c6cb1",
      "id": null,
      "metadata": {},
      "name": "EventLogListPaginationQuery",
      "operationKind": "query",
      "text": "query EventLogListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: IntegrationEventLogItemFilter = {}\n) {\n  ...EventLogList_eventLogItems_3sueo6\n}\n\nfragment EventLogList_eventLogItems_3sueo6 on Query {\n  integrationEventLogItems(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        createdAt\n        ...EventLogRow_eventLogItem\n        __typename\n      }\n    }\n  }\n}\n\nfragment EventLogRow_eventLogItem on IntegrationEventLogItem {\n  id\n  createdAt\n  eventLogSourceId\n  eventLogType\n  eventLogTitle\n  eventLogLevel\n  eventLogMessage\n}\n"
    }
  };
}();
node18.hash = "a286690a6b590aaf0fe577b747e7a5c4";
var EventLogListPaginationQuery_graphql_default = node18;

// src/logging/components/__generated__/EventLogList_eventLogItems.graphql.ts
var node19 = /* @__PURE__ */ function() {
  var v0 = [
    "integrationEventLogItems"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {},
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EventLogListPaginationQuery_graphql_default
      }
    },
    "name": "EventLogList_eventLogItems",
    "selections": [
      {
        "alias": "integrationEventLogItems",
        "args": null,
        "concreteType": "IntegrationEventLogItemsConnection",
        "kind": "LinkedField",
        "name": "__EventLogList_integrationEventLogItems_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationEventLogItemsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationEventLogItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventLogRow_eventLogItem"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node19.hash = "a286690a6b590aaf0fe577b747e7a5c4";
var EventLogList_eventLogItems_graphql_default = node19;

// src/logging/components/EventLogList.tsx
import { useCallback as useCallback18 } from "react";
import { usePaginationFragment as usePaginationFragment4 } from "react-relay";
import { EdListHeader as EdListHeader4, EdTable as EdTable5 } from "shared-ui";

// src/logging/components/__generated__/EventLogRow_eventLogItem.graphql.ts
var node20 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventLogRow_eventLogItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogSourceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogMessage",
      "storageKey": null
    }
  ],
  "type": "IntegrationEventLogItem",
  "abstractKey": null
};
node20.hash = "489a9a291c22c7879e6af9b7f608ac4f";
var EventLogRow_eventLogItem_graphql_default = node20;

// src/logging/components/EventLogRow.tsx
import { useCallback as useCallback17 } from "react";
import { useFragment as useFragment6 } from "react-relay";
import { EdActionCell as EdActionCell4, EdColumnCell as EdColumnCell5, EdRow as EdRow5, LinkButton as LinkButton5 } from "shared-ui";
import { parseDate, timeAgo as timeAgo2 } from "shared-lib";
import { jsx as jsx22, jsxs as jsxs18 } from "react/jsx-runtime";
var fragment7 = EventLogRow_eventLogItem_graphql_default;
var EventLogRow = (props) => {
  const data = useFragment6(fragment7, props.eventLogItem);
  const select = useCallback17(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs18(EdRow5, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx22(EdColumnCell5, { children: timeAgo2(parseDate(data.createdAt)) }),
    /* @__PURE__ */ jsx22(EdColumnCell5, { children: data.eventLogType }),
    /* @__PURE__ */ jsx22(EdColumnCell5, { children: data.eventLogTitle }),
    /* @__PURE__ */ jsx22(EdColumnCell5, { children: data.eventLogLevel }),
    /* @__PURE__ */ jsx22(EdColumnCell5, { children: data.eventLogMessage }),
    /* @__PURE__ */ jsx22(EdActionCell4, { children: /* @__PURE__ */ jsx22(LinkButton5, { label: "Select", clicked: select }) })
  ] });
};
var EventLogRow_default = EventLogRow;

// src/logging/components/EventLogList.tsx
import { jsx as jsx23, jsxs as jsxs19 } from "react/jsx-runtime";
var columns4 = [
  { id: "created", name: "Created" },
  { id: "type", name: "Type" },
  { id: "title", name: "Title" },
  { id: "level", name: "Level" },
  { id: "message", name: "Message" }
];
var fragment8 = EventLogList_eventLogItems_graphql_default;
var EventLogList = ({
  onSelect,
  eventLogItemsKey
}) => {
  const select = useCallback18((e) => {
    onSelect({
      id: e.id
    });
  }, []);
  const paging = usePaginationFragment4(fragment8, eventLogItemsKey);
  const { data } = paging;
  const { integrationEventLogItems } = data;
  const rows = integrationEventLogItems?.edges?.map((e) => {
    return /* @__PURE__ */ jsx23(EventLogRow_default, { eventLogItem: e.node, selected: select }, e.node.id);
  });
  return /* @__PURE__ */ jsxs19("div", { children: [
    /* @__PURE__ */ jsx23(EdListHeader4, { paging }),
    /* @__PURE__ */ jsx23("div", { className: "flex", children: /* @__PURE__ */ jsx23("div", { className: "w-full", children: /* @__PURE__ */ jsx23(EdTable5, { defaultColumns: columns4, rows }) }) })
  ] });
};
export {
  AllEntityEventTypes,
  BullhornCandidateEntity,
  BullhornEntities,
  BullhornJobOrderEntity,
  BullhornJobSubmissionEntity,
  BullhornSystem,
  useCreateFieldMappingConfig as CreateFieldMappingConfigMutation,
  CreateFieldMappingFieldForm,
  ElevateApplicationEntity,
  ElevateEntities,
  ElevateProfileEntity,
  ElevateSystem,
  ElevateVacancyEntity,
  EmployerMappingEditForm,
  EmployerMappingList,
  EmployerMappingNewForm,
  EntityEventTypes,
  EventLogItem,
  EventLogItemLevelList,
  EventLogItemTypesList,
  EventLogList,
  EventLogRow,
  FieldMappingConfigurationCreateForm,
  FieldMappingConfigurationDetail_default as FieldMappingConfigurationDetail,
  FieldMappingConfigurationEditForm,
  FieldMappingConfigurationFieldsForm,
  FieldMappingConfigurationList_default as FieldMappingConfigurationList,
  FieldMappingConfigurationRow_default as FieldMappingConfigurationRow,
  FieldMappingEditor,
  FieldMappingFieldsList,
  FieldMappingSelector_default as FieldMappingSelector,
  IntegrationEntityMap,
  IntegrationSystems,
  MappableDataType,
  MappableProcessorType,
  SaveFieldMappingConfigMutation_default as SaveFieldMappingConfigMutation,
  VacancyContainer,
  VacancyDetails,
  dataTypes,
  fieldDefinitionToListItem,
  fieldDefinitionsToListItems,
  getDataType,
  hasFieldDefinition,
  hasValueField,
  integrationFieldMappingToListItem,
  integrationFieldMappingsToListItems,
  processTypes,
  useSaveFieldMappingConfig
};
//# sourceMappingURL=index.mjs.map